import { MarkedExtension } from 'marked';

export function codeCopyExtension(): MarkedExtension {
  return {
    renderer: {
      code(code: string, infostring: string | undefined): string {
        const language = infostring || 'plaintext';
        const escapedCode = code
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');

        // Store the original unescaped code in a data attribute for copying
        const dataCode = code
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;');

        return `
          <div class="code-block-wrapper">
            <span class="code-block-language">${language}</span>
            <button
              class="code-block-copy"
              onclick="
                (function(btn) {
                  const code = btn.getAttribute('data-code');
                  const textarea = document.createElement('textarea');
                  textarea.value = code;
                  textarea.style.position = 'fixed';
                  textarea.style.opacity = '0';
                  document.body.appendChild(textarea);
                  textarea.select();
                  try {
                    document.execCommand('copy');
                    const icon = btn.querySelector('.code-block-copy-icon');
                    if (icon) {
                      icon.textContent = 'check';
                      btn.classList.add('copied');
                      setTimeout(function() {
                        icon.textContent = 'content_copy';
                        btn.classList.remove('copied');
                      }, 2000);
                    }
                  } catch (err) {
                    console.error('Failed to copy:', err);
                  } finally {
                    document.body.removeChild(textarea);
                  }
                })(this);
              "
              data-code="${dataCode}"
              type="button">
              <span class="code-block-copy-icon material-icons">content_copy</span>
            </button>
            <pre><code class="language-${language}">${escapedCode}</code></pre>
          </div>
        `;
      }
    }
  };
}
